export default __webpack_public_path__ + "static/media/bing_road.75293dba.png";